// type
import { Schedule } from '../types/schedule';
// service
import { axiosInstance } from '../common/axios-interceptor';

// 環境変数
const MOCK_MODE: boolean = process.env.REACT_APP_MOCK_MODE === "true";
const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * ダミーデータ
 */
const mockSchedules: Schedule[] = [
    { id: "1", title: "テスト1", start: "2025-07-07T15:00:00", end: "2025-07-07T15:30:00", userId: "" },
    { id: "2", title: "テスト2", start: "2025-07-14T15:00:00", end: "2025-07-14T15:30:00", userId: ""  },
    { id: "3", title: "テスト3", start: "2025-07-21T15:00:00", end: "2025-07-21T15:30:00", userId: ""  },
    { id: "4", title: "テスト4", start: "2025-08-07T15:00:00", end: "2025-08-07T15:30:00", userId: ""  },
    { id: "5", title: "テスト5", start: "2025-08-14T15:00:00", end: "2025-08-14T15:30:00", userId: ""  },
    { id: "6", title: "テスト6", start: "2025-08-21T15:00:00", end: "2025-08-21T15:30:00", userId: ""  },
    { id: "7", title: "テスト7", start: "2025-09-07T15:00:00", end: "2025-09-07T15:30:00", userId: ""  },
    { id: "8", title: "テスト8", start: "2025-09-14T15:00:00", end: "2025-09-14T15:30:00", userId: ""  },
    { id: "9", title: "テスト9", start: "2025-09-21T15:00:00", end: "2025-09-21T15:30:00", userId: ""  }
];

let schedules = [...mockSchedules];

/**
 * データ取得
 * @param start 
 * @param end 
 * @returns 
 */
export const fetchSchedules = async (start: string, end: string) => {
    if (MOCK_MODE) {
        const startDate = new Date(start);
        const endDate = new Date(end);

        const filtered = schedules.filter((schedule) => {
            const scheduleStart = new Date(schedule.start);
            return scheduleStart >= startDate && scheduleStart < endDate;
        });
        return new Promise<Schedule[]>((resolve) => {
            setTimeout(() => resolve(filtered), 500);
        });
    } else {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/schedule?toStart=${start}&toEnd=${end}`);
            return response.data;
        } catch (e) {
            console.log(e);
            return null;
        }
    }
};

/**
 * スケジュールデータ更新
 * @param schedule 
 * @returns 
 */
export const upsertSchedule = async (schedule: Schedule) => {
    if (MOCK_MODE) {
        return new Promise<Schedule>((resolve) => {
            setTimeout(() => {
                schedules = schedules.map(op => op.id === schedule.id ? schedule : op);
                resolve(schedule);
            }, 500);
        });
    } else {
        try {
            const response = await axiosInstance.post(`${BASE_URL}/schedule/`, schedule);
            return response.data;
        } catch (e) {
            console.log(e);
            return null;
        }
    }
};

/**
 * スケジュールデータ削除
 * @param id 
 * @returns 
 */
export const deleteSchedule = async (id: string) => {
    if (MOCK_MODE) {
        return new Promise<void>((resolve) => {
            setTimeout(() => {
                schedules = schedules.filter(op => op.id !== id);
                resolve();
            }, 500);
        });
    } else {
        try {
            await axiosInstance.delete(`${BASE_URL}/schedule/${id}`);
            return {};
        } catch (e) {
            console.log(e);
            return null;
        }
        
    }
};